export default __webpack_public_path__ + "static/media/tw_brandorodriguez.43c077fb.svg";